<web-settings-breadcrumbs>
    <div class="breadcrumb-icon">
        <a (click)="onReset()">
            <img src="assets/img/websites/lpc-back-icon.svg" class="first-breadcrumb-icon" alt="lpc-back-icon" />
        </a>
    </div>
    <div class="breadcrumb-text">
        <span>{{ "control_chatbot_settings" | translate }}</span>
    </div>
</web-settings-breadcrumbs>

<div class="panel-options-body">
    <form (submit)="$event.preventDefault()">
        <div class="form-group mb-20" [class.has-error]="saveDisablePredicate">
            <div class="input-group">
                <div class="input-group-btn" dropdown>
                    <button dropdownToggle type="button" class="btn btn-default type-dropdown-toggle">
                        <img
                            class="element-icon mr-10"
                            src="./assets/img/websites/social-icons/{{ iconType.value }}/{{ socialNetwork.value }}-{{
                                iconType.value
                            }}.svg"
                            alt="facebook"
                        />
                        <span class="caret"></span>
                    </button>
                    <ul class="dropdown-menu dropdown-overflow-wrapper" *dropdownMenu>
                        <ng-container *ngFor="let messenger of messengerNames">
                            <li [class.selected]="messenger === socialNetwork.value" (click)="setMessenger(messenger)">
                                <a>
                                    <span class="dropdown-icon mr-10">
                                        <img
                                            src="./assets/img/websites/social-icons/logos/{{ messenger }}-logos.svg"
                                            alt="facebook"
                                        />
                                    </span>
                                    {{ messenger | titlecase }}
                                </a>
                            </li>
                        </ng-container>
                    </ul>
                </div>
                <input class="form-control" [formControl]="name" />
            </div>
            <span class="help-block small" *ngIf="saveDisablePredicate">
                {{ "control_errors_required" | translate }}
            </span>
            <p class="analytic-hint small text-muted mb-0" *ngIf="socialNetwork.value === ESocialNetworks.instagram">
                {{ "chat_bot_ig_hint" | translate }}
                <a
                    href="https://developers.facebook.com/docs/messenger-platform/instagram/features/ig-me-links#refparams"
                    target="_blank"
                >
                    {{ "chat_bot_see_more" | translate }}
                    <img
                        class="font-icon-light"
                        src="./assets/img/websites/lpc-new-window-icon.svg"
                        alt="new-window-icon"
                    />
                </a>
            </p>
            <p class="analytic-hint small text-muted mb-0" *ngIf="socialNetwork.value === ESocialNetworks.messenger">
                {{ "chat_bot_me_hint" | translate }}
                <a href="https://developers.facebook.com/community/threads/1048245513262620/" target="_blank">
                    {{ "chat_bot_see_more" | translate }}
                    <img
                        class="font-icon-light"
                        src="./assets/img/websites/lpc-new-window-icon.svg"
                        alt="new-window-icon"
                    />
                </a>
            </p>
        </div>

        <!-- показываем если ранее выбран стиль "Кнопка" -->
        <!-- <div class="form-group mb-20">
            <label class="w-100">
                {{ 'control_description' | translate }}
                <span class="pull-right color-light char-count">
                    {{ description?.value?.length || 0 }}/{{ MAX_DESCRIPTION_LENGTH }}
                </span>
            </label>
            <div>
                <input class="form-control" [placeholder]="'default_description' | translate" [formControl]="description">
            </div>
        </div> -->

        <!-- показываем если есть ранее созданные боты у нас -->
        <div
            *ngIf="chatBotsList?.length > 0"
            class="form-group"
            [class.mb-20]="!botId.value"
            [class.mb-10]="botId.value"
        >
            <div class="form-group">
                <label class="control-label">{{ "subscribe_to" | translate }}</label>
                <div class="wrap-dropdown-control input-group">
                    <div class="input-group-btn" dropdown>
                        <button
                            dropdownToggle
                            type="button"
                            class="btn btn-default type-dropdown-toggle chat-bot-select"
                            [class.disabled]="isChainsLoading"
                        >
                            <span *ngIf="botName.value">{{ botName.value }}</span>
                            <span *ngIf="!botName.value">{{ "provide_link" | translate }}</span>
                            <span class="caret"></span>
                        </button>
                        <ul class="dropdown-menu dropdown-overflow-wrapper" *dropdownMenu>
                            <li *ngFor="let chatBot of chatBotsList" (click)="setBot(chatBot)">
                                <a>{{ chatBot.name }}</a>
                            </li>
                            <li *ngIf="!isSubscriptionForm"><hr /></li>
                            <li (click)="useOwnLink()" *ngIf="!isSubscriptionForm">
                                <a>{{ "provide_link" | translate }}</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

        <ng-container *ngIf="chatBotChains$ | async as chains">
            <div *ngIf="botId.value && chains?.length" class="help-block small">
                <div>{{ "post_subscription_chain" | translate }}</div>
                <span class="dropdown dropdown-chains" dropdown>
                    <a class="dotted-toggle" data-toggle="dropdown" dropdownToggle>
                        <span class="selected-chain">{{ chainName.value }}</span>
                    </a>

                    <ul class="dropdown-menu dropdown-overflow-wrapper dropdown-menu-center" *dropdownMenu>
                        <li *ngFor="let chain of chains" class="padding-10" (click)="setBotChain(chain)">
                            <a class="small text-nowrap" [title]="chain.name">
                                {{ chain.name }}
                            </a>
                        </li>
                    </ul>
                </span>
            </div>
        </ng-container>

        @if (!botId.value && !isSubscriptionForm) {
            <div class="form-group mb-10">
                <label>{{ "control_link" | translate }}</label>
                <input class="form-control" [placeholder]="getPlaceholder(socialNetwork.value)" [formControl]="link" />
            </div>
        }

        @if (socialNetwork.value === ESocialNetworks.telegram && !botId.value) {
            <div class="form-group mb-0">
                <label class="checkbox-inline">
                    <input
                        type="checkbox"
                        [formControl]="preventLinkConverting"
                        [checked]="preventLinkConverting.value"
                    />
                    {{ "prevent_link_wrapping" | translate }}
                </label>
                <!--            <br />-->
                <!--            <a href="#" target="_blank">-->
                <!--                {{ "prevent_link_wrapping_tooltip" | translate }}-->
                <!--                <small class="sp-icon small-xs icon-outgoing color-light"> </small>-->
                <!--            </a>-->
            </div>
        }
    </form>
</div>

<web-settings-footer
    [isSaveDisabled]="saveDisablePredicate"
    (saveEvent)="onSave()"
    (cancelEvent)="onReset()"
></web-settings-footer>
